import * as React from 'react';
import {
    Box,
    Card,
    CardHeader,
    CardContent,
    Typography,
    Stack,
    ButtonBase,
} from '@mui/material';
import {
    TextField,
    useTranslate,
    useListContext,
    RaRecord,
    RecordContextProvider,
    ReferenceField,
    useRedirect,
    useRecordContext,
} from 'react-admin';
import Label, { statusText } from "../../components/Label";
import { useTranslation } from "react-i18next";
import { map } from './list';
import { formatDateTime, formatEuro } from '../../utils/paymentFormat';

const StatusLabel = () => {
    const { t }: { t: any } = useTranslation();
    let conversion = useRecordContext();

    if (!conversion.status) conversion.status = "ERROR";

    const statusKey = conversion?.status?.toUpperCase();
    const statusData = map[statusKey] || { text: "UNKNOWN", state: "warning" };
    const { text, state } = statusData;

    return (
      <Label color={state}>
        {t(statusText(text))}
      </Label>
    );
  };
interface MobileGridProps {
    data?: RaRecord[];
}

// A card row: the label in secondary text, the value right-aligned in bold.
const Row = ({ label, children }: { label: string; children: React.ReactNode }) => (
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
        <Typography variant="body2" color="text.secondary">
            {label}
        </Typography>
        <Box sx={{ typography: 'body2', fontWeight: 600, textAlign: 'right', '& .MuiTypography-root': { fontWeight: 'inherit' } }}>
            {children}
        </Box>
    </Stack>
);

const MobileGrid = (_props: MobileGridProps) => {
    const { data, isLoading } = useListContext();

    if (isLoading || !data || data.length === 0) {
        return null;
    }

    return (
        <Box margin="0.5em">
            {data.map(record => (
                <RecordContextProvider key={record.id} value={record}>
                    <ConversionCard />
                </RecordContextProvider>
            ))}
        </Box>
    );
};

const ConversionCard = () => {
    const record = useRecordContext();
    const redirect = useRedirect();
    const translate = useTranslate();

    return (
        <ButtonBase
            onClick={() => redirect(`/cryptoOrders/${record.orderId}/show`)}
            sx={{ width: '100%', textAlign: 'left' }}
        >
            <Card
                variant="outlined"
                sx={{
                    width: '100%',
                    marginBottom: 2,
                    borderRadius: 2,
                    boxShadow: 1,
                    transition: 'box-shadow 0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: 3,
                    },
                }}
            >
                <CardHeader
                    title={
                        <Typography variant="h4" fontWeight="bold">
                            {record.internalRef || `#${record.id}`}
                        </Typography>
                    }
                    subheader={
                        <Typography variant="body2" color="text.secondary">
                            {formatDateTime(record.dateCreated)}
                        </Typography>
                    }
                />
                <CardContent sx={{ pt: 0 }}>
                    <Stack spacing={1}>
                        <Row label={translate('Status')}>
                            <StatusLabel />
                        </Row>
                        <Row label={translate('Crypto amount')}>
                            {`${record.base} ${String(record.baseCurrency || '').toUpperCase()}`}
                        </Row>
                        <Row label={translate('Payout amount')}>
                            {formatEuro(record.quote) || '—'}
                        </Row>
                        <Row label={translate('Account')}>
                            <ReferenceField source="accountId" reference="accounts" link={false}>
                                <TextField source="name" />
                            </ReferenceField>
                        </Row>
                    </Stack>
                </CardContent>
            </Card>
        </ButtonBase>
    );
};

export default MobileGrid;
